<template>
  <div class="container text-center container_bg">
    <h2 class="pt-6">{{title}}</h2>
    <Step :arr="arr"
          class="mt-6 mb-6"></Step>
    <div style="width: 80%; margin: 0 auto">
      <PDFRender :url="url" />
    </div>
    <div class="pay">
      <el-button type="primary"
                 class="mt-3 mb-3"
                 @click="handleBack">返回</el-button>
      <el-button type="primary"
                 class="mt-3 mb-3"
                 @click="handleNext">下一步</el-button>
    </div>
  </div>

</template>

<script>
import Step from '../../../../components/CA/Step'
import pdf from '@/components/pdf/pdf'
import store from '../mixins/store'

export default {
  data() {
    return {
      arr: [
        { icon: 1, span: '保函样张确认', status: 'active', time: '' },
        { icon: 2, span: '申请书签订', status: '', time: '' },
        { icon: 3, span: '', status: '', time: '' },
      ],
      title: '保函样张确认',
      stepType: 1,
    }
  },
  mixins: [store],
  components: {
    Step,
    PDFRender: pdf,
  },
  computed: {
    url() {
      return `/zcjf/base/file/download/${this.$route.query.pdfId}`
    },
  },
  beforeMount() {
    // 取缓存中的支付方式
    const paymentType = this.state.paymentType
      ? this.state.paymentType
      : this.$route.query.paymentType
    if (paymentType === '0') {
      this.arr[2].span = '订单支付'
    } else {
      this.arr[2].span = '上传电汇底单'
    }
  },
  methods: {
    handleBack() {
      this.$router.replace({
        path: this.$route.query.backType,
        query: {
          ...this.$route.query,
        },
      })
    },
    handleNext() {
      this.$router.push({
        path: '/electronic_bank_pdf_view_ok',
        query: {
          ...this.$route.query,
          backType: this.$route.path,
          lastBackType: this.$route.query.backType,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.pay {
  text-align: center;
  margin-top: 20px;
  padding-bottom: 20px;
  /deep/ button {
    padding: auto;
    width: auto;
    font-size: 15px;
  }
}
</style>
